import PlayerCreatedMatches from '@commons/matches/player-created'
import React from 'react'

const MatchroomCreated = ({ user }) => {
  return <PlayerCreatedMatches userId={user.id} />
}

export default MatchroomCreated
